export const isUsaZipValid = (zip: string) => {
  return /^\d{5}(?:[-\s]\d{4})?$/.test(zip);
};
